<template>
    <CommonDialog v-show="show" class="message-dialog" :title="message.title" :show-close-button="false">
        <template v-slot:msg>
            <span class="dialog-message">{{ message.content}}</span>
        </template>
        <template v-slot:buttons>
            <div class="space"></div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
export default {
    name: "MessageDialog",
    data() {
        return {
            show: false,
            message: {
                title: "",
                content: "存檔中..."
            }
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        showDialog(title, message) {
            this.message.title = title;
            this.message.content = message;
            this.show = true;
        },
        handleClose() {
            this.show = false;
        }
    }
}
</script>

<style scoped>
.message-dialog {
    z-index: 9999;
}
.space {
    margin-bottom: 1rem;
}
</style>